import cn from 'classnames';
import React from 'react';
import {RemoveScroll} from 'react-remove-scroll';

import {twx} from '@/utils/tailwindUtils';

import AppPopup from './AppPopup';
import styles from './Popup.module.scss';
import useOneModalOnPageAtATime from './useOneModalOnPageAtATime';

const PopupSticked = (props) => {
    const {className, overlayClassName, children, onClose, isBlockerOverlay, isOpen = true, ...rest} = props;
    const isVisible = useOneModalOnPageAtATime({isOpen});

    if (!isVisible) return null;

    return (
        <RemoveScroll>
            <AppPopup
                isOpen={isOpen}
                className={twx(
                    'fixed bottom-0 left-0 z-[101] max-h-full w-full overflow-auto overscroll-contain rounded-t-3xl bg-romance px-4 pt-0 pb-safe-or-8',
                    'ml:left-1/2 ml:top-1/2 ml:ml-[calc(var(--sidebar-width)/2)] ml:mt-[calc(var(--hw-h)/2)] ml:h-min ml:max-w-[458px] ml:-translate-x-1/2 ml:-translate-y-1/2 ml:rounded-3xl ml:px-8 ml:py-8',
                    className
                )}
                overlayClassName={cn(styles.Overlay, isBlockerOverlay && styles.BlockerOverlay, overlayClassName)}
                onClose={onClose}
                isCloseVisible={false}
                {...rest}
            >
                {children}
            </AppPopup>
        </RemoveScroll>
    );
};

export default PopupSticked;
